module.exports = __webpack_public_path__ + "img/567x600px-SmartHome.95574f41.jpg";